import { render, staticRenderFns } from "./ListUsersPage.vue?vue&type=template&id=06c95f7c"
import script from "./ListUsersPage.vue?vue&type=script&lang=js"
export * from "./ListUsersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports